import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconZoomOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10.6602,
  cy: 9.97275,
  r: 5.97275,
  fill: "none",
  stroke: "black",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.83008 10.0029H13.2813",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 15.0939,
  y1: 14.7202,
  x2: 19.3129,
  y2: 18.9392,
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
export { IconZoomOut };